import React from "react";
import { cn } from "../../lib/utils";

interface DarkBackgroundProps {
  className?: string;
}

export const DarkBackground: React.FC<DarkBackgroundProps> = ({
  className,
}) => {
  return (
    <div className={cn("absolute inset-0", className)}>
      {/* Simple dark background with subtle gradient */}
      <div className="absolute inset-0 bg-background" />

      {/* Subtle overlay pattern */}
      <div className="absolute inset-0 bg-gradient-to-br from-background via-background to-muted/20" />

      {/* Optional: Very subtle grid pattern */}
      <div
        className="absolute inset-0 opacity-[0.02]"
        style={{
          backgroundImage: `
            linear-gradient(rgba(255,255,255,0.1) 1px, transparent 1px),
            linear-gradient(90deg, rgba(255,255,255,0.1) 1px, transparent 1px)
          `,
          backgroundSize: "100px 100px",
        }}
      />
    </div>
  );
};
